export const APPSTORE_LINK = 'https://apps.apple.com/kr/app/pocapan-%ED%8F%AC%EC%B9%B4%ED%8C%90/id6449088562'
export const GOOGLEPLAY_LINK = 'https://play.google.com/store/apps/details?id=com.peacecover.pocapan&hl=ko'
